import api from "../api";

let cache = null;
// Shared synergy map {slug: [{slug, reason}]} fetched once per page load.
export const loadSynergies = () => {
  if (!cache) cache = api.get("/synergies").then(({ data }) => data || {}).catch(() => ({}));
  return cache;
};
